import { useMemo, useState } from 'react';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { Chip, IconButton, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { ListagemProvider } from 'context/ListagemContext';
import { SellersVtexHistoricoModal, SellersVtexStatusModal } from 'pages/logistica/sellers-vetex/components';
import { useQuerySellersVtex } from 'pages/logistica/sellers-vetex/hooks';
import { SellerVtex } from 'pages/logistica/sellers-vetex/types';

const getRows = (data: SellerVtex[] = []) =>
    data.map((item) => ({
        id: item.idSeller,
        idSeller: item.idSeller,
        dsNome: item.dsNome,
        fgAtivo: item.fgAtivo,
    }));

export function SellersVtexGrid() {
    const { data, isFetching, refetch } = useQuerySellersVtex();
    const [sellerHistorico, setSellerHistorico] = useState<string | null>(null);
    const [editingSeller, setEditingSeller] = useState<SellerVtex | null>(null);
    const rows = useMemo(() => getRows(data?.data), [data]);

    const columns: GridColDef[] = [
        { field: 'idSeller', headerName: 'Código', flex: 1, minWidth: 220, sortable: false },
        { field: 'dsNome', headerName: 'Seller', flex: 1, minWidth: 220, sortable: false },
        {
            field: 'fgAtivo',
            headerName: 'Status',
            align: 'center',
            headerAlign: 'center',
            minWidth: 100,
            sortable: false,
            valueFormatter: (value) => (value ? 'Ativo' : 'Inativo'),
        },
        {
            field: 'acoes',
            headerName: 'Ações',
            align: 'center',
            headerAlign: 'center',
            minWidth: 100,
            sortable: false,
            filterable: false,
            renderCell: ({ row }) => (
                <Tooltip title="Editar status">
                    <IconButton onClick={() => setEditingSeller(row)}>
                        <EditOutlinedIcon />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            field: 'historico',
            headerName: 'Histórico',
            align: 'center',
            headerAlign: 'center',
            minWidth: 110,
            filterable: false,
            sortable: false,
            hideable: false,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <Tooltip title="Visualizar histórico">
                    <IconButton onClick={() => setSellerHistorico(row.idSeller)}>
                        <HistoryOutlinedIcon />
                    </IconButton>
                </Tooltip>
            ),
        },
    ];

    return (
        <>
            <Block>
                <PanelGrid rows={rows} rowsCount={data?.total ?? 0} reload={refetch} loading={isFetching} columns={columns} />
            </Block>

            {editingSeller && <SellersVtexStatusModal open={Boolean(editingSeller)} seller={editingSeller} setOpen={setEditingSeller} />}

            {sellerHistorico && (
                <ListagemProvider>
                    <SellersVtexHistoricoModal
                        open={Boolean(sellerHistorico)}
                        setOpen={(open) => !open && setSellerHistorico(null)}
                        idSeller={sellerHistorico}
                    />
                </ListagemProvider>
            )}
        </>
    );
}
